import * as React from 'react';

function SvgIconMessageCenter(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" {...props}>
      <path
        fillRule="evenodd"
        d="M17.875.625a1.5 1.5 0 011.5 1.5v11.423a1.5 1.5 0 01-1.5 1.5H8.66l-5.098 5.098a.498.498 0 01-.275.14l-.079.007a.5.5 0 01-.5-.5v-4.745h-.583a1.5 1.5 0 01-1.5-1.5V2.125a1.5 1.5 0 011.5-1.5h15.75zm-6.347 8.75H4.722c-.537 0-.972.364-.972.813 0 .448.435.812.972.812h6.806c.537 0 .972-.364.972-.813 0-.448-.435-.812-.972-.812zM15.312 5H4.688c-.518 0-.938.364-.938.813 0 .448.42.812.938.812h10.625c.517 0 .937-.364.937-.813 0-.448-.42-.812-.938-.812z"
      />
    </svg>
  );
}

export default SvgIconMessageCenter;
